import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {ScreenLayoutMenuData, TouchItemData} from "../../../screen-layout.data";
import {ScreenLayoutEditorModel} from "../screen-layout-editor.model";
import {Subscription} from "rxjs";
import {ColorEditControlComponent} from "../../../../../framework/common-controls/edit-controls/color-edit-control/color-edit-control.component";
import {FormGroup} from "@angular/forms";
import {EntityFormBuilder} from "../../../../../framework/entity/edit/entity-form-builder/entity-form-builder";
import {ScreenLayoutEntityModel} from "../../../screen-layout-entity.model";
import {EditService} from "../../../../../framework/entity/edit/edit-page/edit.service";

/**
 * Properties for a selected menu
 */
@Component({
    selector: "wbo-screen-layout-menu-properties",
    templateUrl: "./screen-layout-menu-properties.component.html",
    styleUrls: ["./screen-layout-menu-properties.component.scss"]
})
export class ScreenLayoutMenuPropertiesComponent implements OnInit, OnDestroy {
    menu: ScreenLayoutMenuData;
    item: TouchItemData;
    courseDefinitionId: number;

    private subscriptions: Subscription = new Subscription();

    formGroup: FormGroup;

    constructor(public model: ScreenLayoutEditorModel,
                public entityModel: ScreenLayoutEntityModel,
                private entityFormBuilder: EntityFormBuilder,
                private changeDetectorRef: ChangeDetectorRef,
                public editService: EditService) {
    }

    ngOnInit(): void {
        this.formGroup = this.entityFormBuilder.groupCollection(this.entityModel, "configCategories", 0);

        this.subscriptions.add(this.editService.$entityRestricted.subscribe(restricted => {
            if (restricted) {
                this.editService.restrictAllControls(this.formGroup);
            }
        }));

        this.subscriptions.add(this.model.selectedMenu$.subscribe(menu => {
            this.menu = menu;
            if (this.formGroup) {
                this.formGroup.markAsPristine();
            }
            this.changeDetectorRef.detectChanges();
        }));

        this.subscriptions.add(this.model.selectedItem$.subscribe((value) => {
            this.item = <TouchItemData>value;
            this.changeDetectorRef.detectChanges();
        }));

        this.subscriptions.add(this.model.courseDefinitionId$.subscribe((value) => {
            this.courseDefinitionId = value;
            this.changeDetectorRef.detectChanges();
        }));

        const thiz = this;
        this.model.registerRecordValidator(() => this.validateForm.call(thiz));
    }

    validateForm(): Promise<boolean> {
        if (!this.menu || !this.formGroup.dirty) {
            return Promise.resolve(true)
        } else {
            if (!this.formGroup.valid) {
                this.entityFormBuilder.markControlsAsTouched(this.formGroup);
            }
            return Promise.resolve(this.formGroup.valid)
        }
    }

    ngOnDestroy(): void {
        this.model.unregisterRecordValidator(this.validateForm);
        this.subscriptions.unsubscribe();
    }

    get displayName(): string {
        let name: string = this.menu.displayName;
        if (name) {
            name = name.replace(/<br\s*\/?>/mg, "\n");
        }
        return name;
    }

    set displayName(value: string) {
        if (value) {
            value = value.replace(/(?:\r\n|\r|\n)/g, "<br>");
        }
        this.menu.displayName = value;
    }
    get colour(): string {
        return ColorEditControlComponent.toColorHex(this.menu.colour);
    }

    set colour(value: string) {
        this.menu.colour = ColorEditControlComponent.fromColorHex(value);
    }

    get foreColour(): string {
        return ColorEditControlComponent.toColorHex(this.menu.foreColour);
    }

    set foreColour(value: string) {
        this.menu.foreColour = ColorEditControlComponent.fromColorHex(value);
    }

    get courseId(): number {
        return this.menu.courseId;
    }

    set courseId(value: number) {
        this.menu.courseId = value;
    }

    get gridRows(): number {
        return this.menu.gridRows;
    }

    set gridRows(value: number) {
        this.menu.gridRows = value;
    }

    get gridColumns(): number {
        return this.menu.gridColumns;
    }

    set gridColumns(value: number) {
        this.menu.gridColumns = value;
    }
}
